import React from 'react';
import styles from './BackupRestoreGuide.module.css';

const RESTORE_COMMAND = `cd HydroMastery.API
node scripts/restoreBackup.js "C:\\\\path\\\\to\\\\hydromastery-backup.zip" --confirm`;

/**
 * Collapsible restore instructions shown below the backup download button.
 * Restore is CLI-only; the zip file is the single artefact required.
 */
export default function BackupRestoreGuide() {
    return (
        <details className={styles.restoreHelp}>
            <summary>How to restore from backup</summary>

            <p className={styles.restoreIntro}>
                You do <strong>not</strong> need a new Atlas cluster. Stay on the same cluster and
                choose one of these:
            </p>

            <ul className={styles.restoreOptions}>
                <li>
                    <strong>Restore into the existing database</strong> — keep the same{' '}
                    <code>DATABASE_URL</code>. Restore replaces all backed-up collections. Use this
                    to roll back or recover.
                </li>
                <li>
                    <strong>Restore into a new database on the same cluster</strong> — change only
                    the database name in <code>DATABASE_URL</code> (e.g.{' '}
                    <code>.../hydromastery_restored?...</code>), then restore into that empty
                    database. Your current data stays untouched.
                </li>
            </ul>

            <ol className={styles.restoreSteps}>
                <li>
                    Set <code>DATABASE_URL</code> in <code>HydroMastery.API/.env</code> to the
                    database you want to restore into.
                </li>
                <li>Take a fresh backup first if you can.</li>
                <li>From the API project folder, run:</li>
            </ol>

            <pre className={styles.restoreCommand}>{RESTORE_COMMAND}</pre>

            <p className={styles.restoreNote}>
                Use the path to your downloaded .zip file. The <code>--confirm</code> flag is
                required. Restart the API afterwards, then re-run the dashboard index planner
                (a restore drops each collection together with its indexes):{' '}
                <code>node scripts/migrations/2026-11-dashboard-indexes.js</code> (dry run), then add{' '}
                <code>--confirm</code>. Users can log in with their existing
                passwords but will need to sign in again.
            </p>
        </details>
    );
}
